import {
  getObject,
  getOptionalObject,
  getBoolean,
  getOptionalBoolean,
} from "@surya-digital/leo-ts-types";
import { SurveyLocalizedText, SurveyLocalizedTextDTO } from "../assets/surveyLocalizedText";
import { Code, CodeDTO } from "./code";
import { GridColumnQuestionTypeV1 } from "./gridColumnQuestionTypeV1";
import { GridSize, GridSizeDTO } from "./gridSize";

export interface GridColumnV1DTO {
  columnHeader?: SurveyLocalizedTextDTO | null;
  columnCode: CodeDTO;
  columnQuestionType: GridColumnQuestionTypeV1.GridColumnQuestionTypeV1DTO;
  gridColumnSize?: GridSizeDTO | null;
  isUnanswered?: boolean | null;
}

export class GridColumnV1 {
  readonly isGridColumnV1GridColumnV1: boolean = true;

  readonly columnHeader: SurveyLocalizedText | null;
  readonly columnCode: Code;
  readonly columnQuestionType: GridColumnQuestionTypeV1.GridColumnQuestionTypeV1;
  readonly gridColumnSize: GridSize | null;
  readonly isUnanswered: boolean | null;


  constructor(
  columnHeader: SurveyLocalizedText | null = null, 
  columnCode: Code, 
  columnQuestionType: GridColumnQuestionTypeV1.GridColumnQuestionTypeV1, 
  gridColumnSize: GridSize | null = null, 
  isUnanswered: boolean | null = null
  ) {
    this.columnHeader = columnHeader;
    this.columnCode = columnCode;
    this.columnQuestionType = columnQuestionType;
    this.gridColumnSize = gridColumnSize;
    this.isUnanswered = isUnanswered;
  }

  static fromDTO(dto: GridColumnV1DTO): GridColumnV1 {
    let columnHeader = getOptionalObject(dto, "columnHeader");
    if(columnHeader !== undefined && columnHeader !== null) {
      columnHeader = SurveyLocalizedText.fromDTO(getObject(dto, "columnHeader", InvalidGridColumnV1ColumnHeaderError));
    }
    const columnCode = Code.fromDTO(getObject(dto, "columnCode", InvalidGridColumnV1ColumnCodeError));
    const columnQuestionType = GridColumnQuestionTypeV1.fromDTO(getObject(dto, "columnQuestionType", InvalidGridColumnV1ColumnQuestionTypeError));
    let gridColumnSize = getOptionalObject(dto, "gridColumnSize");
    if(gridColumnSize !== undefined && gridColumnSize !== null) {
      gridColumnSize = GridSize.fromDTO(getObject(dto, "gridColumnSize", InvalidGridColumnV1GridColumnSizeError));
    }
    const isUnanswered = getOptionalBoolean(dto, "isUnanswered", InvalidGridColumnV1IsUnansweredError);
    return new GridColumnV1(
      columnHeader,
      columnCode,
      columnQuestionType,
      gridColumnSize,
      isUnanswered
    );
  }

  toDTO(): GridColumnV1DTO {
    const dto: GridColumnV1DTO = {
        columnCode: this.columnCode.toDTO(),
        columnQuestionType: this.columnQuestionType.toDTO(),
    };
    if (this.columnHeader !== undefined && this.columnHeader !== null){
      dto.columnHeader = this.columnHeader.toDTO();
    }
    if (this.gridColumnSize !== undefined && this.gridColumnSize !== null){
      dto.gridColumnSize = this.gridColumnSize.toDTO();
    }
    if (this.isUnanswered !== undefined && this.isUnanswered !== null){
      dto.isUnanswered = this.isUnanswered;
    }
    return dto;
  }
  }

GridColumnV1.prototype.toString = function toString(): string {
  return `GridColumnV1(columnHeader='${this.columnHeader}',columnCode='${this.columnCode}',columnQuestionType='${this.columnQuestionType}',gridColumnSize='${this.gridColumnSize}',isUnanswered='${this.isUnanswered}')`;
};

export class InvalidGridColumnV1Error extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridColumnV1Error";
  }
}
export class InvalidGridColumnV1ColumnHeaderError extends InvalidGridColumnV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridColumnV1ColumnHeaderError";
  }
}

export class InvalidGridColumnV1ColumnCodeError extends InvalidGridColumnV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridColumnV1ColumnCodeError";
  }
}

export class InvalidGridColumnV1ColumnQuestionTypeError extends InvalidGridColumnV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridColumnV1ColumnQuestionTypeError";
  }
}

export class InvalidGridColumnV1GridColumnSizeError extends InvalidGridColumnV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridColumnV1GridColumnSizeError";
  }
}

export class InvalidGridColumnV1IsUnansweredError extends InvalidGridColumnV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridColumnV1IsUnansweredError";
  }
}
